import { useNavigate } from "react-router-dom";

export default function PageUnload({ path }) {
  const navigate = useNavigate();
  const handleUnload = async () => {
    navigate(path);
    document.querySelector("#close-modal-button").click();
  };

  return (
    <>
      <div className="w-75 text-center mx-auto">
        <span className="mb-5 d-block">
          Sei sicuro di voler chiudere la seguente pillola formativa?
        </span>
      </div>
      <div className="d-flex align-items-center gap-3 w-100">
        <button
          className="q8-blue-button px-3 py-2 ms-auto"
          onClick={() => document.querySelector("#close-modal-button").click()}
        >
          Annulla
        </button>
        <button
          className="q8-blue-button px-3 py-2"
          onClick={() => handleUnload()}
        >
          Conferma
        </button>
      </div>
    </>
  );
}
